import React, { useEffect } from 'react';
import './MailerliteSubscribeForm.css';

const MailerliteSubscribeForm = ({ title = "Updates", description = "Stay updated with new arrivals." }) => {
  useEffect(() => {
    // Load MailerLite webforms script
    const script = document.createElement('script');
    script.src = 'https://groot.mailerlite.com/js/w/webforms.min.js?v176e10baa5e7ed80d35ae235be3d5024';
    script.type = 'text/javascript';
    document.head.appendChild(script);

    // Load tracking script
    const trackingScript = document.createElement('script');
    trackingScript.innerHTML = `
      fetch("https://assets.mailerlite.com/jsonp/1365877/forms/158782149952014056/takel")
    `;
    document.head.appendChild(trackingScript);

    // Define success callback
    window.ml_webform_success_27900721 = function() {
      const $ = window.ml_jQuery || window.jQuery;
      if ($) {
        $('.ml-subscribe-form-27900721 .row-success').show();
        $('.ml-subscribe-form-27900721 .row-form').hide();
      }
    };

    return () => {
      // Cleanup scripts on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (trackingScript.parentNode) {
        trackingScript.parentNode.removeChild(trackingScript);
      }
    };
  }, []);

  return (
    <div id="mlb2-27900721" className="ml-form-embedContainer ml-subscribe-form ml-subscribe-form-27900721">
      <div className="ml-form-align-center">
        <div className="ml-form-embedWrapper embedForm">
          <div className="ml-form-embedBody ml-form-embedBodyDefault row-form">
            <div className="ml-form-embedContent">
              <h4>{title}</h4>
              <p>{description}</p>
            </div>

            <form 
              className="ml-block-form" 
              action="https://assets.mailerlite.com/jsonp/1365877/forms/158782149952014056/subscribe" 
              data-code="" 
              method="post" 
              target="_blank"
            >
              <div className="ml-form-formContent">
                <div className="ml-form-fieldRow ml-last-item">
                  <div className="ml-field-group ml-field-email ml-validate-email ml-validate-required">
                    <input 
                      aria-label="email" 
                      aria-required="true" 
                      type="email" 
                      className="form-control" 
                      data-inputmask="" 
                      name="fields[email]" 
                      placeholder="Email" 
                      autoComplete="email"
                    />
                  </div>
                </div>
              </div>

              <input type="hidden" name="ml-submit" value="1" />

              <div className="ml-form-embedSubmit">
                <button type="submit" className="primary">Subscribe</button>
                <button disabled style={{ display: 'none' }} type="button" className="loading">
                  <div className="ml-form-embedSubmitLoad"></div>
                  <span className="sr-only">Loading...</span>
                </button>
              </div>

              <input type="hidden" name="anticsrf" value="true" />
            </form>
          </div>

          <div className="ml-form-successBody row-success" style={{ display: 'none' }}>
            <div className="ml-form-successContent">
              <h4>Thank you!</h4>
              <p>You have successfully joined our subscriber list.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailerliteSubscribeForm; 